module.exports = __webpack_public_path__ + "static/media/carnival.af49708d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightBrowse/img/events/carnival.jpeg
// module id = 1041
// module chunks = 0